export type ScenarioNavigation = {
  step: SCENARIO_STEP;
  type: 'internal' | 'external';
};

export type Color = 'green' | 'orange' | 'blue' | 'red' | 'dark';

export type Badge = {
  type: 'primary' | 'secondary';
  title: string;
  color: Color;
  icon?: string;
};

export type Summary = {
  value: string;
  valueRaw:
    | number
    | {
        from: number;
        to: number;
      };
  label: string;
  text: string;
  tooltip: string;
};

export type GroupName =
  | 'MplActiveGroup'
  | 'MplPendingGroup'
  | 'MplRefusedGroup'
  | 'SuperRelevant'
  | 'MplReceivedGroup'
  | 'MfoOffers';

export interface StatusStep {
  id: string;
  title: string;
  prev?: string;
  subtitle?: string;
  ordering: number;
  isActive: boolean;
}

export interface StatusBlock {
  title: string;
  stepProgress: StatusStep[];
}

export type ButtonType = 'primary' | 'secondary' | 'text' | 'outlined';

export type TButtonFlow<InteractionClick = never> = {
  label?: string;
  id?: string;
  title?: string;
  onClick: TOnClickFlow | InteractionClick;
  type?: ButtonType;
  disabled?: boolean;
  color?: Color;
};

export type TPayload = {
  organizationId?: number;
  amount?: number;
  term?: string;
  agreementId?: string;
} & Record<string, any>;

export type TAction = {
  step: SCENARIO_STEP;
  payload?: TPayload;
  redirectUrl?: string;
};

export type TOnClickFlow = {
  type: string;
  action: TAction;
};

/**
 * Базовый интерфейс для сценариев, который содержит общие поля
 * Step - шаг сценария
 * Content - контент
 * Interactions - если не передали тип для interaction, то interaction не будет в подсказках
 */
export type BaseScenario<Step extends SCENARIO_STEP, Content, Interactions = never> = {
  analytics?: {
    flow?: {
      category?: number;
      subCategory?: number;
    };
    calcId?: string;
  };
  step: Step;
  flowId: string;
  type: 'internal' | 'external';
  redirectUrl?: string;
  content: Content;
  nextStep?: ScenarioNavigation;
  prevStep?: ScenarioNavigation;
} & (Interactions extends never ? {} : { interactions: Interactions });

export enum SCENARIO_STEP {
  BANKS_REFUSED = 'BANKS_REFUSED',
  CREDIT_SELECTION = 'CREDIT_SELECTION',
  CREDIT_OFFERS_LOADING = 'CREDIT_OFFERS_LOADING',
  PRODUCT_ISSUED = 'PRODUCT_ISSUED',
  GO_TO_LEADGEN = 'GO_TO_LEADGEN',
  OFFER_DISBURSEMENT = 'OFFER_DISBURSEMENT',
}

export interface INextScenarioRequest {
  flow: string;
  step?: SCENARIO_STEP;
  owner: number;
  platform?: string;
  payload?: TPayload & { analytics?: Record<string, unknown> };
}

export interface IStartScenarioRequest {
  scenarioName: string;
  owner: number;
  platform: string;
}

export interface ISendStepScenarioRequest {
  step: SCENARIO_STEP;
}

export interface IStartScenarioResponse {
  item: string;
}
